import React from 'react'
import "../components/css/footer.css"

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-heading">@copyright 2022-2028 
      </div>
      <div>
        <p className="para-heading">
          All right reversed. Power by the HARSH JOSHI Term of Use | Privacy policy
        </p>
      </div>
    </div>
  )
}

export default Footer

